module.exports = __webpack_public_path__ + "static/img/img7.061b443.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regist/img7.png
// module id = TWSp
// module chunks = 1